import type { Document } from '@features/documents/api/types/document.types';

export function filterDocumentsByName(
  documents: Document[],
  searchText: string
): Document[] {
  const normalizedSearch = searchText.toLowerCase().trim();
  if (!normalizedSearch) return documents;
  return documents.filter(doc =>
    doc.name.toLowerCase().includes(normalizedSearch)
  );
}
